// extracted by mini-css-extract-plugin
module.exports = {"searchbarButton":"searchbar-icon-button-module--searchbarButton--Kb-v8"};